module.exports = __webpack_public_path__ + "img/partner_pc.2d9eb5da.png";